(function () {
  angular
    .module('kareo.ui.shared.directives.k-patient-check-eligibility.directive', [
      'kareo.ui.shared.components.k-therapy-cap'
    ])
    .directive('kPatientCheckEligibility', [
      function () {
        return {
          controller: 'PatientCheckEligibilityController',
          controllerAs: 'vm',
          bindToController: true,
          scope:
          {
            eligibilityPaneClass: '=?',
            patient: '=',
            insurance: '=',
            serviceTypeCode: '@'
          },
          template: require('./index.pug')()
        };
      }
    ]);
})();
